var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  Subscription changed from\n  "),_c('strong',[_vm._v(_vm._s(_vm.eventLog.existingPlan))]),_vm._v(" to\n  "),_c('strong',[_vm._v(_vm._s(_vm.eventLog.currentPlan))])])}
var staticRenderFns = []

export { render, staticRenderFns }